import { ICellEditorAngularComp } from 'ag-grid-angular';
import { GridApi } from 'ag-grid-enterprise';
import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { RecordNaicsInputComponent } from '@shared/components/inputs/record-naics-input/record-naics-input.component';
import { DataObject } from '@shared/models/data-object.model';
import { AgGridOptionsEditType, MiqAgColumn } from '../ag-table-grid-options';

@Component({
  selector: 'miq-ag-naics-input',
  template: `
    <ng-container *ngIf="column">
      <miq-record-naics-input
        #input
        [currentValue]="currentValue"
        (currentValueChange)="setCurrentValue($event)"
        [recordDetail]="column"
        [disabled]="column.isDisabled"
      ></miq-record-naics-input>
    </ng-container>
  `,
  standalone: false,
})
export class AgNaicsInputComponent implements ICellEditorAngularComp, AfterViewInit {
  params: DataObject;
  currentValue: any;
  column: MiqAgColumn;

  private apiGrid: GridApi;

  @ViewChild('input', { read: RecordNaicsInputComponent, static: false }) public input: RecordNaicsInputComponent;

  /**
   * Required by ICellEditorAngularComp
   */
  agInit(params: any) {
    this.apiGrid = params.api;
    this.params = params;
    this.currentValue = params.value;
    this.column = params.colDef;
  }

  /**
   * Required by ICellEditorAngularComp
   */
  ngAfterViewInit() {
    if (this.params.gridOptions?.editType !== AgGridOptionsEditType.FullRow) {
      setTimeout(() => this.input.toggleOverlay());
    }
  }

  /**
   * Set's current value from event
   * @param param0
   */
  setCurrentValue({ value }: MiqAgColumn) {
    this.currentValue = value;
    if (this.params.gridOptions?.editType !== AgGridOptionsEditType.FullRow) {
      this.apiGrid.stopEditing();
    }
  }

  /**
   * Required by ICellEditorAngularComp
   */
  getValue() {
    return this.currentValue;
  }

  ngOnDestroy() {
    this.input = null;
  }
}
